/**
 * The `cta-section-3` "Subscribe & Join With Us" band. Extracted so the
 * services listing and each service detail page share one implementation.
 * The background is set inline instead of via `data-img-src` so it survives
 * SPA route changes without re-running the jQuery background initializer.
 */
export function SubscribeCta({ sectionClassName }: { sectionClassName?: string }) {
  return (
    <section className={`cta-section-3${sectionClassName ? ` ${sectionClassName}` : ''} pb-100 md-pb-80`}>
      <div className="container">
        <div
          className="cta-wapper"
          style={{ backgroundImage: 'url(/assets/images/cta/background-cta-shape.png)' }}
        >
          <div className="row align-items-end justify-content-between">
            <div className="col-lg-5">
              <div className="cta-content">
                <div className="section-title">
                  <h2>Subscribe &amp; Join With Us Now !</h2>
                  <p>Get free health tips and hospital updates from Fast Aid Hospital</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cta-form">
                <div className="cta-shape">
                  <img src="/assets/images/cta/cta-shape-1.png" alt="image" />
                </div>
                <form action="#" onSubmit={(event) => event.preventDefault()}>
                  <div className="form-group mb-0">
                    <div className="form-floating field-inner">
                      <input
                        id="subscribe"
                        name="subscribe"
                        className="form-control white-field"
                        placeholder="Enter Address"
                        type="text"
                        autoComplete="off"
                      />
                      <label htmlFor="subscribe">Enter Address </label>
                      <button
                        type="submit"
                        className="theme-button style-3"
                        aria-label="subscribe"
                        data-text="Subscribe Now"
                      >
                        <span data-text="Subscribe Now">Subscribe Now</span>
                        <i className="fa-solid fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
